import React from 'react';
import Auth from '../modules/Auth';
import { Link, withRouter } from 'react-router-dom';
import { FontAwesomeIcon as FontAwesome } from '@fortawesome/react-fontawesome';

class Footer extends React.Component {

  render() {
    return (
      <footer className="w-100 text-white bg-dark py-4 py-lg-5">
        <div className="container">
          <div className="row">
            <div className="col-12 col-xl-6 mb-3 m-xl-0">
              <p className="font-weight-medium text-uppercase mb-3">
                About Sprint Boards
              </p>

              <p>
                We provide a free online tool for distributed teams to coordinate, discuss and collaborate together in real time.
              </p>
            </div>

            <div className="col-12 col-xl-6">
              <div className="row links">
                <div className="col-12 col-sm-4 mb-3 mb-sm-0">
                  <p className="font-weight-medium text-uppercase mb-3">
                    Company
                  </p>

                  <ul>
                    <li>
                      <Link to="/support/create">
                        Contact Us
                      </Link>
                    </li>

                    <li>
                      <a href="/help/releases">
                        Release History
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="col-12 col-sm-4 mb-3 mb-sm-0">
                  <p className="font-weight-medium text-uppercase mb-3">
                    Account
                  </p>

                  {Auth.user() === null && (
                    <ul>
                      <li>
                        <Link to="/auth/login">
                          Login
                        </Link>
                      </li>

                      <li>
                        <Link to="/auth/register">
                          Register
                        </Link>
                      </li>
                    </ul>
                  )}

                  {Auth.user() !== null && (
                    <ul>
                      <li>
                        <Link to="/auth/account">
                          Settings
                        </Link>
                      </li>

                      <li>
                        <Link to="/auth/integrations">
                          Integrations
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>

                <div className="col-12 col-sm-4">
                  <p className="font-weight-medium text-uppercase mb-3">
                    Boards
                  </p>

                  <ul>
                    <li>
                      <Link to="/boards/create">
                        Create Board
                      </Link>
                    </li>

                    <li>
                      <Link to="/boards">
                        Board History
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-xl-7">
              <p className="mt-3 mb-0 copyright-line">
                Copyright &copy; 2018 &ndash; 2025 Sprint Boards. All rights reserved.

                {' '}

                <Link to="/terms" className="d-inline-block d-md-inline mt-1 mt-md-0">
                  Terms and Privacy
                </Link>
              </p>
            </div>
          </div>
        </div>
      </footer>
    );
  }

}

export default withRouter(Footer);
